module.exports = __webpack_public_path__ + "static/img/ikonaFilmDisabled-ON.5db0501a.png";